const waitForElement = (selector, callback, delay = 0, failsafeDelay) => {
  const observer = new MutationObserver((mutations, obs) => {
    const element = document.querySelector(selector);
    if (element) {
      obs.disconnect();
      if (typeof callback === "function") {
        setTimeout(() => {
          callback(element);
        }, delay);
      }
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  if (failsafeDelay) setTimeout(() => observer.disconnect(), failsafeDelay);
};

//if awtomic bab purchase flow
if (window.location.pathname.includes("/products/")) {
  waitForElement(".awtomic-sw__price-current", () => {
    let lastVariant = new URLSearchParams(location.search).get("variant");

    const checkVariant = () => {
      const variant = new URLSearchParams(location.search).get("variant");

      if (variant !== lastVariant) {
        location.reload();
      }
    };

    const pushState = history.pushState;
    history.pushState = (...args) => {
      pushState.apply(history, args);
      checkVariant();
    };

    const replaceState = history.replaceState;
    history.replaceState = (...args) => {
      replaceState.apply(history, args);
      checkVariant();
    };

    window.addEventListener("popstate", checkVariant);
  });
}

